import { Component, OnInit } from '@angular/core';
import { APIManager, Server, Service, ServiceService } from "@flashvpn-io/web-core";
import { StatusService } from "../../services/status.service";

@Component({
    selector: 'app-server-page',
    templateUrl: './servers.component.html',
    styleUrls: ['./servers.component.css']
})
export class ServersPage implements OnInit {
    public servers: Server[] = [{
        id: 1,
        localId: '1',
        serviceId: 1,
        name: 'DEFAULT SERVER',
        host: '127.0.0.1',
        port: 8080,
        status: 1,
        country: 'Hong Kong',
        description: 'Hong Kong Default Server',
        type: 'VIP2',
        probe: 'ping',
        tags: ['Hong Kong', 'VIP2'],
        username: 'test',
        password: 'test',
        uuid: 'test',
        latency: '100ms',
        ping: () => 100
    }];
    public service: Service = new Service('', '', '', '', 0, '', {}, '', 0);

    constructor(
        private statusService: StatusService,
        private serviceService: ServiceService,
        private apiManager: APIManager
    ) { }


    ngOnInit(): void {
        this.refreshServerList();
    }

    refreshServerList(): void {
        // 先使用缓存数据
        const cachedServers = this.statusService.getServersFromLocalStorage();
        if (cachedServers && cachedServers.length > 0) {
            this.servers = cachedServers;
        }

        // 尝试从网络获取最新数据
        this.serviceService.currentService$.subscribe({
            next: (service) => {
                if (service) {
                    this.service = service;
                    this.apiManager.fetchServers(service).subscribe({
                        next: (servers) => {
                            if (servers && servers.length > 0) {
                                console.log('刷新成功：从网络获取服务器列表', servers);
                                this.servers = servers;
                                this.statusService.setServers(servers);
                            } else {
                                console.log('刷新结果：网络返回空数据，继续使用缓存');
                            }
                        },
                        error: (error) => {
                            console.error('刷新失败：获取服务器列表出错，使用缓存数据', error);
                        }
                    });
                }
            },
            error: (error) => {
                console.error('刷新失败：获取服务信息出错', error);
            }
        });
    }
}
